/**
 * Pack size selector — lets customers choose pack sizes (single, 6-pack, etc.)
 *
 * Hides the original quantity selector and replaces it in-place with a custom one.
 * The custom qty = "how many packs". The hidden original input is kept in sync:
 * actual cart quantity = pack_size × custom_qty.
 *
 * On submit, the cart line just has qty = packSize × customQty. The Discount
 * Function applies pack pricing automatically based on quantity.
 */
(function () {
  var selector = document.getElementById('pack-size-selector');
  if (!selector) return;

  var btnBox = selector.querySelector('.btn-box');
  var priceDisplay = document.getElementById('pack-price-display');

  var currentPackSize = 1;
  var currentPackPrice = 0;
  var customQty = 1;
  var trackInventory = selector.getAttribute('data-track-inventory') === 'true';
  var available = parseInt(selector.getAttribute('data-available'), 10);
  if (isNaN(available)) available = 0;

  function maxPacks() {
    if (!trackInventory) return Infinity;
    return Math.floor(available / currentPackSize);
  }

  var origQtyComponent = document.querySelector(
    'product-form-component quantity-selector-component'
  );
  if (!origQtyComponent) return;

  var customQtyEl = document.createElement('div');
  customQtyEl.className = 'pack-qty-selector';
  customQtyEl.id = 'pack-qty-selector';
  customQtyEl.innerHTML =
    '<button type="button" class="pack-qty-minus" aria-label="Decrease quantity">' +
    '<svg width="10" height="2" viewBox="0 0 10 2"><path d="M0 0h10v2H0z" fill="currentColor"/></svg>' +
    '</button>' +
    '<span class="pack-qty-value">1</span>' +
    '<button type="button" class="pack-qty-plus" aria-label="Increase quantity">' +
    '<svg width="10" height="10" viewBox="0 0 10 10"><path d="M4 0h2v10H4z" fill="currentColor"/><path d="M0 4h10v2H0z" fill="currentColor"/></svg>' +
    '</button>';

  origQtyComponent.parentNode.insertBefore(customQtyEl, origQtyComponent);
  origQtyComponent.style.display = 'none';

  var qtyDisplay = customQtyEl.querySelector('.pack-qty-value');
  var minusBtn = customQtyEl.querySelector('.pack-qty-minus');
  var plusBtn = customQtyEl.querySelector('.pack-qty-plus');

  // Inject hidden line item property input into the form
  var form = document.querySelector('product-form-component form');
  var submitBtn = null;
  var stockMsg = null;
  if (form) {
    submitBtn = form.querySelector('button[type="submit"], [type="submit"]');
    stockMsg = document.createElement('div');
    stockMsg.className = 'pack-stock-msg';
    stockMsg.style.cssText = 'display:none;margin-top:8px;color:#b00020;font-size:14px;';
    if (submitBtn && submitBtn.parentNode) {
      submitBtn.parentNode.insertBefore(stockMsg, submitBtn.nextSibling);
    } else {
      form.appendChild(stockMsg);
    }
  }

  function findOriginalInput() {
    var input = origQtyComponent.querySelector('input[name="quantity"]');
    if (!input) input = document.querySelector('input[name="quantity"]');
    return input;
  }

  function syncOriginalInput() {
    var input = findOriginalInput();
    if (!input) return;
    var actualQty = currentPackSize * customQty;
    var nativeSetter = Object.getOwnPropertyDescriptor(
      HTMLInputElement.prototype,
      'value'
    ).set;
    nativeSetter.call(input, actualQty);
  }

  // Parse extra packs from JSON
  var extraDataEl = document.getElementById('pack-extra-data');
  if (extraDataEl) {
    try {
      var extraPacks = JSON.parse(extraDataEl.textContent);
      if (Array.isArray(extraPacks)) {
        extraPacks.forEach(function (pack) {
          if (pack.qty > 1) {
            var p = document.createElement('p');
            p.setAttribute('data-qty', pack.qty);
            p.setAttribute('data-price', pack.price);
            p.textContent = pack.qty + ' Pack';
            btnBox.appendChild(p);
          }
        });
      }
    } catch (e) {}
  }

  function formatPrice(amount) {
    return '$' + parseFloat(amount).toFixed(2);
  }

  function updatePriceDisplay() {
    if (!priceDisplay) return;
    if (currentPackSize <= 1) {
      priceDisplay.style.display = 'none';
      return;
    }
    var perUnit = currentPackPrice / currentPackSize;
    var totalEl = priceDisplay.querySelector('.pack-total-price');
    var perUnitEl = priceDisplay.querySelector('.pack-per-unit-price');
    if (customQty > 1) {
      totalEl.textContent =
        formatPrice(currentPackPrice * customQty) +
        ' for ' + currentPackSize * customQty + ' bottles';
    } else {
      totalEl.textContent =
        formatPrice(currentPackPrice) + ' for ' + currentPackSize + ' bottles';
    }
    perUnitEl.textContent = '(' + formatPrice(perUnit) + ' each)';
    priceDisplay.style.display = '';
  }

  function updateStockState() {
    if (!trackInventory) return;
    var insufficient = currentPackSize > available;
    if (stockMsg) {
      if (insufficient) {
        stockMsg.textContent = 'Only ' + available + ' in stock — not enough for a ' + currentPackSize + '-pack.';
        stockMsg.style.display = '';
      } else {
        stockMsg.style.display = 'none';
      }
    }
    if (submitBtn) {
      submitBtn.disabled = insufficient;
      submitBtn.setAttribute('aria-disabled', insufficient ? 'true' : 'false');
      submitBtn.style.opacity = insufficient ? '0.5' : '';
      submitBtn.style.cursor = insufficient ? 'not-allowed' : '';
    }
  }

  function updateAll() {
    qtyDisplay.textContent = customQty;
    syncOriginalInput();
    updatePriceDisplay();
    updateStockState();
  }

  // Pack button clicks
  btnBox.addEventListener('click', function (e) {
    var btn = e.target.closest('p[data-qty]');
    if (!btn) return;

    btnBox.querySelectorAll('p[data-qty]').forEach(function (p) {
      p.classList.remove('active');
    });
    btn.classList.add('active');

    currentPackSize = parseInt(btn.getAttribute('data-qty'), 10);
    currentPackPrice = parseFloat(btn.getAttribute('data-price'));
    customQty = 1;
    if (trackInventory && currentPackSize > available) {
      customQty = 0;
    }
    updateAll();
  });

  minusBtn.addEventListener('click', function () {
    if (customQty > 1) { customQty--; updateAll(); }
  });

  plusBtn.addEventListener('click', function () {
    if (customQty + 1 > maxPacks()) return;
    customQty++; updateAll();
  });

  // Block add-to-cart when requested qty exceeds stock
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!trackInventory) return;
      var requested = currentPackSize * customQty;
      if (customQty < 1 || requested > available) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  // Initial sync
  updateAll();
})();
